import { render, staticRenderFns } from "./AccordeonFaq.vue?vue&type=template&id=ea461c7a&scoped=true"
import script from "./AccordeonFaq.vue?vue&type=script&lang=js"
export * from "./AccordeonFaq.vue?vue&type=script&lang=js"
import style0 from "./AccordeonFaq.vue?vue&type=style&index=0&id=ea461c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea461c7a",
  null
  
)

export default component.exports